import React, { memo, useEffect } from "react";
import {
  fetchProductsList,
  selectProductsIds,
  selectLoading,
  deleteProduct,
  setProducts,
} from "features/admin/Products/productsAdminSlice";
import { batch, useDispatch, useSelector } from "react-redux";
import GridTable from "../Common/GridTable";
import { useNavigate } from "react-router-dom";
import { ColDef } from "@material-ui/data-grid";
import { setResponseMessage } from "features/admin/adminSlice";

interface AllProductsTableProps {
  type: string;
}
const columns: ColDef[] = [
  {
    sortable: false,
    field: "title",
    headerName: "Име",
    width: 700,
  },
  {
    sortable: false,
    field: "quantity",
    headerName: "Наличност",
    width: 150,
  },
];

const ProductsTable: React.FC<AllProductsTableProps> = ({ type }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useSelector(selectProductsIds);
  const isLoading = useSelector(selectLoading);

  // useEffect(() => {
  //   dispatch(fetchProductsList(type));
  //   return () => {
  //     dispatch(setProducts([]));
  //   };
  // }, [dispatch]);

  // useEffect(() => {
  //   alert(type);
  // }, [toFetch]);

  const add = () => {
    dispatch(setResponseMessage({ message: "", hasError: false }));
    navigate(`/products/add`, {
      state: { type },
    });
  };

  const refresh = () => {
    batch(() => {
      dispatch(setResponseMessage({ message: "", hasError: false }));
      dispatch(fetchProductsList(type));
    });
  };

  const remove = (ids: string[]) => {
    ids.forEach((id: string) => {
      const _refId = data.find((item: { id: number }) => item.id === parseInt(id))?.refId;
      _refId &&
        batch(() => {
          dispatch(setResponseMessage({ message: "", hasError: false }));
          dispatch(deleteProduct(_refId, type));
        });
    });
    dispatch(fetchProductsList(type));
  };

  const edit = (id: string) => {
    const _refId = data.find((item: { id: number }) => item.id === parseInt(id))?.refId;
    dispatch(setResponseMessage({ message: "", hasError: false }));
    _refId &&
      navigate(`/products/edit/${_refId}`, {
        state: { type },
      });
  };

  return (
    <GridTable
      add={add}
      refresh={refresh}
      remove={remove}
      edit={edit}
      data={data}
      columns={columns}
      isLoading={isLoading}
      searchProperty="title"
    />
  );
};

export default memo(ProductsTable);
